/**
 * @fileOverView
 * @description Event Log View<br>
 * @copyright 2015-present Flatirontek LLC
 **/

var AmpersandView = require('ampersand-view');
var ServiceAuthTemplate = require('../../templates/widgets/serviceauthtemplate.html');
var ServiceAuthModel = require("../../models/serviceauth");
var app = require('ampersand-app');

var ServiceAuthView = AmpersandView.extend({

    template: ServiceAuthTemplate,

    initialize: function(options){
        this.model = options.model;
        if (app.profile) this.listenTo(app.profile, 'change:name', this.updateAccountLine);
    },

    bindings: {
        "model.consentTitle": { type: 'text', hook: 'consentTitle' },
        "model.nameNote": [
            { type: 'text', hook: 'nameNote' },
            { type: 'toggle', hook: 'nameNote' }
        ],
        "model.abilitiesLabel": { type: 'text', hook: 'abilitiesLabel' },
        "model.requestsEmail": { type: 'toggle', hook: 'emailAbility' },
        "model.returnLine": [
            { type: 'text', hook: 'returnLine' },
            { type: 'toggle', hook: 'returnLine' }
        ]
    },

    updateAccountLine: function() {
        var name = (app.profile && app.profile.name) || (app.meter && app.meter.name) || '';
        this.queryByHook('accountName').textContent = name;
        this.queryByHook('accountLine').hidden = !name;
    },

    render: function() {
        this.renderWithTemplate(this);
        this.updateAccountLine();
        return this;
    },

    events: {
        "click #auth-service-allow" : "allowService",
        "click #auth-service-decline" : "declineService"
    },

    allowService: function(){ this.model.processAllowRedirect(); },

    declineService: function(){
        const storedRedirectUri = window.localStorage.getItem("redirect_uri");
        const redirectUrl = storedRedirectUri ? 
            decodeURIComponent(storedRedirectUri) : 
            app.config.serviceAuth[this.model.service]?.redirect_uri;
        const state = window.localStorage.getItem("state");

        window.localStorage.clear();
        app.queryParams = {};

        if (!redirectUrl) {
            app.loadData();
            return;
        }

        let url = `${redirectUrl}?error=access_denied`;
        if (state) {
            url += `&state=${encodeURIComponent(state)}`;
        }

        if (app.platform === "app") app.loadData();
        window.location.href = url;
    }

})

module.exports = ServiceAuthView;
